import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../services/security.service';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-pap-cash',
  templateUrl: './pap-cash.component.html',
  styleUrls: ['./pap-cash.component.css'],
})
export class PapCashComponent implements OnInit {
  createdDate = new Date();
  lastDate = new Date();
  stringDate = '';

  constructor(
    private title: Title, 
    private _securityService: SecurityService,
    private _loaderService: LoaderService
  
  ) {
    this.title.setTitle('Onboarding Digital | Pago en Efectivo');
  }

  async ngOnInit() {
    this._loaderService.hide();
    this._securityService.showPapData().subscribe({
      next: async (response: any) => {
        this.createdDate = new Date(response.data.createdAt);

        this.lastDate = new Date(this.createdDate);
        this.lastDate.setDate(this.createdDate.getDate() + 30);
        this.stringDate = this.lastDate.toISOString().split('T')[0];
      },
      error: async (error: any) => {
        console.error(error);
      },
    });
  }

  async next() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href =
      'https://www.fincomercio.com/oficinas-puntos-de-atencion-y-asesores';
  }

  finish() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = 'https://www.fincomercio.com';
  }
}
